import {
  type ProjectActivityFilter,
  PROJECT_ACTIVITY_FILTERS,
} from '@littlebird/ui-utils';
import { type ComponentProps } from 'react';

import { Icons } from '@/assets/icons/icons';
import { XStack } from '@/components/ui';
import { cn } from '@/lib/utils';

export function ProjectActivityToolbar({
  search,
  onSearchChange,
  filter,
  onFilterChange,
  placeholder = 'Search...',
  autoFocus,
  inputProps,
}: {
  search: string;
  onSearchChange: (search: string) => void;
  filter: ProjectActivityFilter;
  onFilterChange: (filter: ProjectActivityFilter) => void;
  placeholder?: string;
  autoFocus?: boolean;
  inputProps?: ComponentProps<'input'>;
}) {
  return (
    <XStack className="items-center gap-2">
      <XStack className="flex-1 items-center gap-2 px-3 py-2 rounded-lg border border-border bg-surface focus-within:border-accent transition-colors">
        <Icons.search className="size-3 text-foreground-muted shrink-0" />
        <input
          aria-label={placeholder}
          {...inputProps}
          type="text"
          autoFocus={autoFocus}
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={placeholder}
          className="flex-1 bg-transparent text-sm outline-none placeholder:text-foreground-muted"
        />
      </XStack>
      <XStack className="items-center gap-1 shrink-0">
        {PROJECT_ACTIVITY_FILTERS.map(({ label, value }) => (
          <FilterButton
            key={value}
            label={label}
            active={filter === value}
            onClick={() => onFilterChange(value)}
          />
        ))}
      </XStack>
    </XStack>
  );
}

function FilterButton({
  label,
  active,
  onClick,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      aria-pressed={active}
      className={cn(
        'px-2.5 py-2 text-sm rounded-md transition-colors',
        active
          ? 'bg-secondary text-foreground'
          : 'text-foreground-muted hover:text-foreground-subtle'
      )}
      onClick={onClick}
    >
      {label}
    </button>
  );
}
